function makeDraggable (element, mobileOnly = false) {

  const data = {};
  data.position = { x: 0, y: 0 };
  data.offset = [0, 0];
  data.isMoving = false;

  const startEvents = mobileOnly ? ['touchstart'] : ['mousedown', 'touchstart'];
  const moveEvents = mobileOnly ? ['touchmove'] : ['mousemove', 'touchmove'];
  const endEvents = mobileOnly ? ['touchend'] : ['mouseup', 'touchend'];

  startEvents.forEach(evt => element.addEventListener(evt, pickup, true));
  moveEvents.forEach(evt => element.addEventListener(evt, move, true));
  endEvents.forEach(evt => element.addEventListener(evt, drop, true));

  function pickup(e) {
    const point = e.touches ? e.touches[0] : e;
    data.isMoving = true;
    data.startX = point.clientX;
    data.startY = point.clientY;
    data.startLeft = element.offsetLeft;
    data.startTop = element.offsetTop;
  }

  function move(e) {
    if (!data.isMoving) return;
    const point = e.touches ? e.touches[0] : e;
    element.style.left = (data.startLeft + point.clientX - data.startX) + 'px';
    element.style.top = (data.startTop + point.clientY - data.startY) + 'px';
  }

  function drop(e) {
    data.isMoving = false;
  }
}

export { makeDraggable };
